import React from 'react';
import { cn } from '@/utils/cn';
import Icon from '../Icon';

function CloseButton({ onClose, className, color = '#fff' }) {
  return (
    <div
      className={cn(
        'hidden lg:flex size-[24px] lg:size-[32px] cursor-pointer ml-auto',
        className,
      )}
    >
      <Icon
        type="close"
        color={color}
        onClick={onClose}
        className="cursor-pointer ml-auto"
      />
    </div>
  );
}

export default CloseButton;
